import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-pr-ticketlist',
  templateUrl: './pr-ticketlist.component.html',
  styleUrls: ['./pr-ticketlist.component.scss']
})
export class PrTicketlistComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
